import React, { useEffect } from 'react';
import { Box, Typography, Container, Divider, Grid, Card, CardContent, Button } from '@mui/material';
import { useParams, Link as RouterLink, useLocation } from 'react-router-dom';
import CaseStudyCard from '../sections/CaseStudyCard';
import JumiaQAReport from '../sections/JumiaQAReport';
import SecurityResearchProject from '../sections/SecurityResearchProject';
import networkimage from '../Assets/network-architecture.png'

// 1. DEFINE THIS ARRAY INSIDE THE FILE, BEFORE THE COMPONENT
const allProjects = [
  { id: 'network-architecture', title: "Enterprise Network Deployment", img: networkimage, component: <CaseStudyCard /> },
  { id: 'jumia-qa', title: "Jumia E-Commerce: QA Report", img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=300", component: <JumiaQAReport /> },
  { id: 'security-research', title: "0-Day CMS Vulnerability", img: "https://images.unsplash.com/photo-1760670399462-f5e479452c27?q=80&w=300", component: <SecurityResearchProject /> }
];

export default function ProjectsPage() {
  const { projectId } = useParams();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const selectedProject = allProjects.find(p => p.id === projectId);
  const otherProjects = allProjects.filter(p => p.id !== projectId);

  return (
    <Container maxWidth="md" sx={{ py: 10 }}>
      {selectedProject ? (
        <>
          <Box sx={{ mb: 8 }}>{selectedProject.component}</Box>
          <Divider sx={{ my: 8 }} />
          
          <Typography variant="h4" sx={{ mb: 4 }}>Other Research & Projects</Typography>
          <Grid container spacing={3}>
            {otherProjects.map((proj) => (
              <Grid item xs={12} sm={4} key={proj.id}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <Box component="img" src={proj.img} sx={{ height: 140, width: '100%', objectFit: 'cover' }} />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h6">{proj.title}</Typography>
                    <Button component={RouterLink} to={`/projects/${proj.id}`} sx={{ mt: 2 }}>View Details</Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <Typography variant="h5">Project not found.</Typography>
      )}
    </Container>
  );
}